"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var options = {
    offset: 100
};
var BpParallax = /** @class */ (function () {
    function BpParallax(clip) {
        this.clip = clip;
        this.container = this.clip.firstElementChild;
        this.sticky = false;
    }
    BpParallax.prototype.init = function () {
        var header = document.getElementById('header');
        var parallax = this.clip.querySelectorAll('*[parallax-start]');
        if (getComputedStyle(document.body).transform == 'none')
            document.body.style.transform = 'translateZ(0)';
        var perspectiveElement;
        if (this.sticky || getComputedStyle(this.clip).webkitOverflowScrolling) {
            this.sticky = true;
            perspectiveElement = this.container;
        }
        else {
            perspectiveElement = this.clip;
            this.container.style.transformStyle = 'preserve-3d';
        }
        perspectiveElement.style.perspectiveOrigin = 'bottom right';
        perspectiveElement.style.perspective = '1px';
        this.prepareItems(parallax);
        parallax.forEach(function (node) {
            node.parentNode.insertBefore(node, node.parentNode.firstChild);
        });
    };
    BpParallax.prototype.prepareItems = function (items) {
        var _this = this;
        var parallaxDetails = [];
        items.forEach(function (node) {
            _this.checkErrors(node);
            if (_this.sticky)
                node.style.position = '-webkit-sticky';
            if (_this.sticky)
                node.style.top = '0';
            node.style.transformOrigin = 'bottom right';
            // Find the previous and next elements to parallax between.
            var previousCover = node.previousElementSibling;
            while (previousCover && previousCover.hasAttribute('parallax-start'))
                previousCover = previousCover.previousElementSibling;
            var nextCover = node.nextElementSibling;
            while (nextCover && !nextCover.hasAttribute('parallax-end'))
                nextCover = nextCover.nextElementSibling;
            parallaxDetails.push({
                node: node,
                nextCover: nextCover,
                previousCover: previousCover
            });
        });
        window.addEventListener('resize', this.parallaxResize.bind(this, parallaxDetails));
        this.parallaxResize(parallaxDetails);
    };
    BpParallax.prototype.parallaxResize = function (details) {
        var _this = this;
        var STICKY = this.sticky;
        var WINDOW_HEIGHT = this.clip.clientHeight;
        var SCROLLBAR_WIDTH = STICKY ? 0 : this.clip.offsetWidth - this.clip.clientWidth;
        var SCROLLBAR_HIGHT = this.clip.scrollHeight;
        var offset = options.offset;
        var common = {
            winH: WINDOW_HEIGHT,
            sticky: STICKY,
            sbW: SCROLLBAR_WIDTH,
            sbH: SCROLLBAR_HIGHT
        };
        var sections = {
            onas: undefined,
            realizacje: undefined,
            kontakt: undefined
        };
        details.forEach(function (item) {
            var _a;
            var parallaxDiv = item.node;
            var hook = parallaxDiv.classList[1].substr(10);
            // HTML DIVS TO EXTRACT CONTSTS
            var container = parallaxDiv.parentNode;
            var previousCover = item.previousCover;
            var nextCover = item.nextCover;
            // CONSTS
            var PARALLAX_START = previousCover ? previousCover.offsetTop + previousCover.offsetHeight : 0;
            var PARALLAX_END = nextCover ? nextCover.offsetTop : container.offsetHeight;
            var data = {
                PARALLAX_START: PARALLAX_START,
                PARALLAX_END: PARALLAX_END
            };
            sections = __assign({}, sections, (_a = {}, _a["" + hook] = data, _a));
            var styles = _this.createStyle(data, common).styles;
            var height = _this.createStyle(data, common).PARALLAX_HEIGHT;
            parallaxDiv.style.transform = styles;
            parallaxDiv.style.marginBottom = "-" + height + "px";
            parallaxDiv.style.height = height + "px";
        });
        var mock = { sections: __assign({}, sections), common: __assign({}, common) };
    };
    BpParallax.prototype.createStyle = function (data, common) {
        var winH = common.winH, sticky = common.sticky, sbW = common.sbW, sbH = common.sbH;
        var PARALLAX_END = data.PARALLAX_END, PARALLAX_START = data.PARALLAX_START;
        var offset = options.offset;
        var roundnumber = function (num) {
            return +(Math.round(num * 1000) / 1000);
        };
        var PARALLAX_HEIGHT = PARALLAX_END - PARALLAX_START + offset;
        var tDiv = PARALLAX_HEIGHT - winH;
        var DIVIDER = tDiv < 0 ? tDiv : -200;
        var depth = 0;
        depth = offset / DIVIDER;
        if (sticky)
            depth = 1.0 / depth;
        var perspective = 1.0 / (1.0 - depth);
        var dx = sbW * (perspective - 1);
        var isSticky = -(sbH - PARALLAX_START - PARALLAX_HEIGHT) * (1 - perspective);
        var isNotSticky = (PARALLAX_START - depth * DIVIDER) * perspective;
        var dy = sticky ? isSticky : isNotSticky;
        var translateZ = roundnumber(depth);
        var translateY = roundnumber(dy);
        var translateX = roundnumber(dx);
        var scale = roundnumber(1 - translateZ);
        var styles = "scale(" + scale + ") translate3d(" + translateX + "px, " + translateY + "px, " + translateZ + "px)";
        return {
            styles: styles,
            PARALLAX_HEIGHT: PARALLAX_HEIGHT
        };
    };
    BpParallax.prototype.checkErrors = function (item) {
        if (getComputedStyle(this.container).overflow != 'visible') {
            console.error('Need non-scrollable container to apply perspective for', item);
            return;
        }
        if (this.clip && this.container.parentNode != this.clip) {
            console.warn('Currently we only track a single overflow clip, but elements from multiple clips found.', item);
        }
        if (getComputedStyle(this.clip).overflow == 'visible') {
            console.error('Parent of sticky container should be scrollable element', item);
            return;
        }
    };
    return BpParallax;
}());
exports.BpParallax = BpParallax;
